import { Component, ElementRef, Inject, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ContactoModel, ForoModel, ResponseForoModel } from 'src/app/model/Contacto.model';
import { EncargadaModel, ResponseEncargadaModel, ResponseEstamentoModel, ResponseUnidadEducativaModel, UnidadEducativaModel } from 'src/app/model/Identificacion.model';
import { JardinModel } from 'src/app/model/Jardin.model';
import { apiService } from 'src/app/service/api.service';
import Swal from 'sweetalert2'
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { JardinComponent } from '../../jardin.component';
import { ConSultaModel, ResponseConSultasModel } from 'src/app/model/Consulta.model';
import { ModalVideoComponent } from '../dialogs/modal-video/modal-video.component';
import { DetalleEstado, ResponseDetalleEstado } from 'src/app/model/DetalleEstado.model';
import { ProyectoEducativoDataModel, ResponseProyectoEducativoDataModel } from 'src/app/model/ProyectoEducativoData.model';



@Component({
  selector: 'app-inicio-jardin',
  templateUrl: './inicio-jardin.component.html',
  styleUrls: ['./inicio-jardin.component.css']
})
export class InicioJardinComponent implements OnInit {
  @ViewChild('modalHistorial', { static: true }) modalHistorial: TemplateRef<any>;
  @ViewChild('modalCapacitacion', { static: true }) modalCapacitacion: TemplateRef<any>;
  @ViewChild('modalAuto', { static: true }) modalAuto: TemplateRef<any>;
  @ViewChild('modalValidacion', { static: true }) modalValidacion: TemplateRef<any>;
  @ViewChild('modalPlanMejoramiento', { static: true }) modalPlanMejoramiento: TemplateRef<any>;
  @Input() simulacion: boolean;
  displayedColumns=[];
  dataSource : MatTableDataSource<ForoModel>;
  @ViewChild(MatSort) sort: MatSort;
  cargando = true
  formContacto = new ContactoModel();
  activeTabContacto;
  consultaEnviada = false;
  uniEducativa = new UnidadEducativaModel(); 
  datosDirec = new EncargadaModel();
  dataJardin = new JardinModel();
  detalleEstado = new DetalleEstado();
  primerNombreDirectora : string;
  consulta : string;
  @ViewChild('divSpinner') divSpinner:ElementRef;
  responseConSultasModel =[];
  estamentos: any;
  showPreguntasFrecuentes : boolean;
  capInProgress: boolean = false;
  capFinished: boolean = false;
  autoInProgress: boolean = false;
  autoFinished: boolean = false;
  valInProgress: boolean = false;
  valFinished: boolean = false;
  planInProgress: boolean = false;
  planFinished: boolean = false;
  peiNoIniciado: boolean = false;
  peiInProgress: boolean = false;
  peiFinished: boolean = false;
  proyectoEducativoData = new ProyectoEducativoDataModel();
  peiCompletos1:number;
  peiCompletos2:number;
  peiCompletos3:number;
  peiCompletos4:number;
  planStatus:number;

  statusCap = "No iniciada";
  statusAuto = "No iniciada";
  statusVal = "No iniciada";
  statusPlan = "No iniciada";
  subStatusAuto = 0;
  subStatusVal = 0;
  
  public rows : DetailColapse[] = [];

  public mdOptions: NgbModalOptions = {
    size: 'md'
  };
  
  
  constructor(
    @Inject(JardinComponent) private parent: JardinComponent,
    private modal: NgbModal,
    private api: apiService,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog,
    // public control: NgControl
  ) { }

  ngOnInit(): void {
    this.cargaInicial();
    this.planStatus = 0;
    this.obtenerDetalleEstado(this.dataJardin);
    this.peiCompletos1 = 0;
    this.peiCompletos2 = 0;
    this.peiCompletos3 = 0;
    this.peiCompletos4 = 0;
    
    this.proyectoEducativo(this.dataJardin);
    this.showPreguntasFrecuentes = false;
    this.consulta = "";
    this.activeTabContacto = this.api.activeTabContacto;
    this.api.activeTabContacto = 0;
    
  }

  cargaInicial(){
    this.consulta = "";
    this.cargando = true;
    this.spinner.show();
    this.dataJardin = this.api.dataJardin;
    this.formContacto.idJardin = this.dataJardin.id
    this.unidadEducativa(this.dataJardin);
    this.getDirectora(this.dataJardin);
    this.cargaEstados();
    this.getMisConsultas();
    this.spinner.hide();
  }

 cargaEstados() {
    this.capInProgress = this.dataJardin.etapaJardin >= 1;
    this.capFinished = this.dataJardin.etapaJardin > 1;
    this.autoInProgress = this.dataJardin.etapaJardin >= 2 ;
    this.autoFinished = this.dataJardin.etapaJardin > 2;
    this.valInProgress = this.dataJardin.etapaJardin >= 3 ;
    this.valFinished = this.dataJardin.etapaJardin > 3 ;
    this.planInProgress = this.dataJardin.etapaJardin >=4 ;
    this.planFinished = this.dataJardin.etapaJardin > 4 ;
    

    if (this.dataJardin.etapaJardin >= 1) {
      this.statusCap = "En proceso";
    }
    if (this.dataJardin.etapaJardin > 1) {
      this.statusCap = "Finalizado";
    }
    if (this.dataJardin.etapaJardin >= 2) {
      this.statusAuto = "En proceso";
    }
    if (this.dataJardin.etapaJardin > 2) {
      this.statusAuto = "Finalizado";
    }
    if (this.dataJardin.etapaJardin >= 3) {
      this.statusVal = "En proceso";
    }
    if (this.dataJardin.etapaJardin > 3) {
      this.statusVal = "Finalizado";
    }
    if (this.dataJardin.etapaJardin >= 4) {
      this.statusPlan = "En proceso";
    }
    if (this.dataJardin.etapaJardin > 4) {
      this.statusPlan = "Finalizado";
    }


  }

  proyectoEducativo(dataJardin:JardinModel){
    this.peiInProgress = false;
    this.peiFinished = false;
    this.peiNoIniciado = false;
    this.api.API_POST_obtenerProyectoEducativoData(dataJardin.id).subscribe((response: ResponseProyectoEducativoDataModel) => {
      this.proyectoEducativoData = response.payload;  
      this.calcularCompletos1();
      this.calcularCompletos2();
      this.calcularCompletos3();
      this.calcularCompletos4();
      if(this.peiCompletos1 === 0 && this.peiCompletos2 === 0 && this.peiCompletos3 === 0 && this.peiCompletos4 === 0){
        this.peiNoIniciado = true;
      }else if(this.peiCompletos1 === 5 && this.peiCompletos2 === 6 && this.peiCompletos3 === 2 && this.peiCompletos4 === 2){
        this.peiFinished = true;
      }else{
        this.peiInProgress = true;
      }
      
    },
    (err) => {
      this.cargando = false;
      console.log(err)
    });  
  }


  calcularCompletos1(){
    if(this.proyectoEducativoData.introduccion.trim() != ""){
      this.peiCompletos1 ++;
    }
    let totalAntecedentesGenerales : Number = this.proyectoEducativoData.capacidadSalacunaMenor + this.proyectoEducativoData.capacidadSalacunaMayor + this.proyectoEducativoData.capacidadSalacunaMixta + this.proyectoEducativoData.capacidadSalacunaNoConvencional + this.proyectoEducativoData.capacidadMedioMenor + this.proyectoEducativoData.capacidadMedioMayor + this.proyectoEducativoData.capacidadTransicion1 + this.proyectoEducativoData.capacidadTransicion2 + this.proyectoEducativoData.heterogeneo;
    if(totalAntecedentesGenerales > 0){
      this.peiCompletos1 ++;
    }
    let totalAntecedentesEspecificos: Number = this.proyectoEducativoData.cantidadDirectora + this.proyectoEducativoData.cantidadEducadora + this.proyectoEducativoData.cantidadTecnico + this.proyectoEducativoData.cantidadAgente + this.proyectoEducativoData.cantidadAdministrativa + this.proyectoEducativoData.cantidadAuxiliar + this.proyectoEducativoData.cantidadManipuladora;
    if(totalAntecedentesEspecificos > 0){
      this.peiCompletos1 ++;
    }
    if(this.proyectoEducativoData.resenaHistorica.trim() != ""){
      this.peiCompletos1 ++;
    }
    if(this.proyectoEducativoData.entorno.trim() != ""){
      this.peiCompletos1 ++;
    }

  }

  calcularCompletos2(){
    if(this.proyectoEducativoData.sello.trim() != ""){
      this.peiCompletos2 ++;
    }
    if(this.proyectoEducativoData.vision.trim() != ""){
      this.peiCompletos2 ++;
    }
    if(this.proyectoEducativoData.mision.trim() != ""){
      this.peiCompletos2 ++;
    }
    if(this.proyectoEducativoData.valores.trim() != ""){
      this.peiCompletos2 ++;
    }
    if(this.proyectoEducativoData.definiciones.trim() != ""){
      this.peiCompletos2 ++;
    }
    if(this.proyectoEducativoData.perfiles.trim() != ""){
      this.peiCompletos2 ++;
    }
  }

  calcularCompletos3(){
    if(this.proyectoEducativoData.objetivosGenerales.trim() != ""){
      this.peiCompletos3 ++;
    }
    if(this.proyectoEducativoData.objetivosEstrategicos.trim() != ""){
      this.peiCompletos3 ++;
    }
  }

  calcularCompletos4(){

    if(this.proyectoEducativoData.seguimiento.trim() != ""){
      this.peiCompletos4 ++;
    }
    if(this.proyectoEducativoData.proyecciones.trim() != ""){
      this.peiCompletos4 ++;
    }

  }

  statusAlert(status){
    let alertStatus = ''
    switch (status) {
      case 'No iniciada':
        alertStatus = 'En espera'
        break;
    case 'En proceso':
      alertStatus = 'En proceso'
      break;
    case 'Finalizado':
      alertStatus = 'Cumplida'
      break;
    default:
      alertStatus = ''
      break;
    }
    return alertStatus
  }

  abrirModalHistorial(){
    this.modal.open(this.modalHistorial, { size: 'lg' });
  }

  abrirModalCapacitacion(){
    this.modal.open(this.modalCapacitacion, this.mdOptions);
  }

  abrirModalAuto(){
    this.modal.open(this.modalAuto, this.mdOptions);
  }

  abrirModalValidacion(){
    this.modal.open(this.modalValidacion,this.mdOptions);
  }

  abrirModalPlanMejoramiento(){
    this.modal.open(this.modalPlanMejoramiento, this.mdOptions);
  }
  

  unidadEducativa(dataJardin:JardinModel){
    this.api.API_POST_obtenerUnidadEducatica(dataJardin.id).subscribe((response: ResponseUnidadEducativaModel) => {
      this.uniEducativa = response.payload;  
    },
    (err) => {
      console.log(err)
    });      
}


obtenerDetalleEstado(dataJardin:JardinModel){
  this.api.API_POST_obtenerDetalleEstadoUE(dataJardin.idJardinPeriodo).subscribe((response: ResponseDetalleEstado) => {
    this.detalleEstado = response.payload;
    this.subStatusAuto = this.detalleEstado.subEstadoAutoevaluacion;
    this.subStatusVal = this.detalleEstado.subEstadoValidacion;  
    this.planStatus = response.payload.planStatus;
  },
  (err) => {
    console.log(err)
  });      
}

getMisConsultas(){
  this.api.API_POST_obtenerMisConsultas().subscribe((response: ResponseConSultasModel) => {
    this.responseConSultasModel = response.payload;
    this.responseConSultasModel.forEach(key => {
      var detailColapse = new DetailColapse();
      detailColapse.detail = key;
      this.rows.push(detailColapse);
    });
    this.divSpinner.nativeElement.style.display='none';
  },
  (err) => {
    console.log(err)
  })
}
getEstamentos(){
  this.api.API_POST_obtenerEstamentos().subscribe((response: ResponseEstamentoModel) =>{
    this.estamentos = response;  
  },(err) => {
    console.log(err)
  })
}


getDirectora(dataJardin:JardinModel){
    this.api.API_POST_obtenerDirectora(dataJardin.id).subscribe((response: ResponseEncargadaModel) => {
      this.datosDirec = response.payload;
      const nombre = this.datosDirec.nombreDirectora.split(' ');
      this.primerNombreDirectora = nombre[0];
      this.divSpinner.nativeElement.style.display='none';
    },
    (err) => {
      console.log(err)
    })
}


verForo(foro:ForoModel){
    console.log(foro)
    this.api.idForo = foro.idForo
    this.api.emitDireccionamiento('consulta');
  }

close(){
  this.modal.dismissAll();
}

irA(){
  this.api.emitDireccionamiento('consulta.model');
}

cambiarMenu(destino){
  this.modal.dismissAll();
  this.parent.menuVisible(destino);
}

enviarMensaje(){
    this.formContacto.idJardin = this.api.dataJardin.id;
    this.formContacto.asunto = "duda o consulta"
    this.formContacto.consulta = this.consulta;
    this.divSpinner.nativeElement.style.display='';
    if(this.consulta != ""){
      this.api.API_POST_crearConsulta(this.formContacto).subscribe((response) => {
        this.formContacto = new ContactoModel();
        this.consulta = "";
        this.getMisConsultas();
        this.divSpinner.nativeElement.style.display='none';
        Swal.fire({
          icon: 'success',
          title: 'Su Consulta se ha Enviado',
          confirmButtonText: 'OK'
        })
      },
      (err) => {
        console.log(err)
      })
    }else{
      this.divSpinner.nativeElement.style.display='none';
      Swal.fire({
        title: 'Error!',
        text: 'El Mensaje es Obligatorio',
        icon: 'error',
        confirmButtonText: 'OK'
      })
    }
    
  
}

verVideo(nombre){
  switch(nombre){
    case 'intro5':{
      const dialogRef = 
        this.dialog.open(ModalVideoComponent, {
          disableClose: true ,
          data: {url: 'assets/documentos/2021/sesion1/MMGCEP.pdf',size: 'xl'}
        });

        dialogRef.afterClosed().subscribe(result => {

        });
      break;
    } 
  }
}


preguntasFrecuentes(){
  this.showPreguntasFrecuentes = true;
}

}



export class DetailColapse{
  detail:ConSultaModel;
  isCollapsed:boolean;

  constructor(){
    this.detail = null;
    this.isCollapsed = true;
  }

}